module.exports = __webpack_public_path__ + "static/img/aboutVideo.cbc0173.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutVideo.png
// module id = kW2Q
// module chunks = 1